import { ComponentProps } from "react";
import { RouteFactory } from "@app/routePaths";
import Card from "@particles/card/Card";
import { useListingLoadMoreStories } from "@particles/listing/hooks/useListingLoadMoreStories";
import { getPodcastKeywordCardProps } from "@routes/Podcasts/PodcastsKeywordPage/utils/helpers";

import PodcastsListingStories from "./PodcastsListingStories";

type PodcastsOverviewProps = {
  /** The list of card props to displayed */
  cardProps: ComponentProps<typeof Card>[];
  /** The entity data for the podcast keyword page */
  tagUrlPath: string;
};

/**
 * Component to render individual podcast listing stories.
 * Figma: https://www.figma.com/design/rmzJoZwUpb3iLm6lMDXJ2W/BT-MASTER--WEB-?node-id=1476-10827&t=m7103yrVxON0jRlB-4
 */
const PodcastsOverview = ({
  cardProps = [],
  tagUrlPath,
}: PodcastsOverviewProps): React.ReactElement => {
  const podcastSection = RouteFactory.podcasts.replace("/", "");

  const { ref, loadMoreData } = useListingLoadMoreStories({
    templateProps: getPodcastKeywordCardProps,
    initialList: cardProps,
    sections: podcastSection,
    urlPath: tagUrlPath,
    size: 5,
    pageType: "keyword",
  });

  return (
    <section data-testid="podcasts-overview-component">
      <div>
        {[...cardProps, ...loadMoreData].map((cardProp, index) => {
          return (
            <PodcastsListingStories
              key={cardProp.id}
              cardProp={cardProp}
              index={index}
            />
          );
        })}
      </div>

      <div ref={ref} />
    </section>
  );
};

export default PodcastsOverview;
